import { withProps, compose, withHandlers, lifecycle, withState } from 'recompose'
import { connect } from 'react-redux'
import { show } from 'redux-modal'
import isEqual from 'lodash/isEqual'
import withHandlePhoneLinkClick from 'components/common/hoc/withHandlePhoneLinkClick'
import { getLocationPathname } from 'selectors/getPageLocation'
import StoreDetails from './StoreDetails'
import googleMapRouteUrl from 'helpers/google-map-route-url'
import { isSSR } from 'helpers/isSSR'
import { workingHoursDistinct, processSpecialHours, generateOpeningHoursSpecification } from './helpers'
import { getPhoneNumberFromObjectWithPrefix, composeFormattedPhoneNumberFromObject } from 'helpers/phone-number'
import { generateSchemaUrl } from 'helpers/SEOSchema'
import { CURBSIDE_SERVICE_MODAL } from 'constant'
import { getIsFleetCertified } from '../../selectors'

const mapStateToProps = (state) => ({
  schemaUrl: generateSchemaUrl(getLocationPathname(state)),
  isFleetCertified: getIsFleetCertified(state)
})

const withFormattedStoreDetails = withProps(({
  coords = {},
  storeInformation: {
    workingHours = [],
    storeAddress: {
      phoneNumber = {}
    } = {},
    storeAddress,
    storeSpecialHours = [],
    storeClosedHours = []
  } = {}
} = {}) => {
  const distinctWorkingHours = workingHoursDistinct(workingHours)
  const schemaOpeningHours = distinctWorkingHours
    && distinctWorkingHours.length && distinctWorkingHours.map(({ schemaHours }) => schemaHours)

  return {
    storeSpecialAndClosedHours: [
      ...processSpecialHours(storeSpecialHours),
      ...processSpecialHours(storeClosedHours)
    ].sort(({ epochNum: epochNumA }, { epochNum: epochNumB }) => epochNumA - epochNumB),
    distinctWorkingHours,
    locationPhoneNumberFormatted: composeFormattedPhoneNumberFromObject(phoneNumber),
    locationPhoneNumberUrl: getPhoneNumberFromObjectWithPrefix(phoneNumber),
    routeToLocationUrl: googleMapRouteUrl({ from: coords, to: storeAddress }),
    schemaOpeningHours,
    openingHoursSpecification: generateOpeningHoursSpecification(workingHours),
    siteDomain: !isSSR ? window.location.origin : ''
  }
})

const withShowStoreDetailsSchemaState = withState('showStoreDetailsSchema', 'setShowStoreDetailsSchema', true)

const withCurbsideServiceHandler = withHandlers({
  handleCurbsideServiceInfo: ({ show }) => () => show(CURBSIDE_SERVICE_MODAL)
})

const withLifecycle = lifecycle({
  componentDidUpdate({ schemaUrl: prevSchemaUrl }) {
    const { schemaUrl, setShowStoreDetailsSchema } = this.props

    if (!isEqual(prevSchemaUrl, schemaUrl)) {
      setShowStoreDetailsSchema(schemaUrl.length < prevSchemaUrl.length)
    }
  }
})

export default compose(
  withFormattedStoreDetails,
  withHandlePhoneLinkClick,
  connect(mapStateToProps, { show }),
  withShowStoreDetailsSchemaState,
  withCurbsideServiceHandler,
  withLifecycle
)(StoreDetails)

